export const steps = [
  [
    ".brand",
    "Welcome to Fontlab",
    "კეთილი იყოს თქვენი მობრძანება Fontlab-ში",
    "Let’s find a Georgian font you love—and show you how to use it. This quick tour points to the real controls, so you’ll know exactly where to go.",
    "მოდით, ვიპოვოთ ქართული შრიფტი, რომელიც მოგეწონებათ, და ვნახოთ, როგორ გამოიყენოთ. ტური გაჩვენებთ რეალურ ღილაკებს, რათა მარტივად გაერკვეთ.",
  ],
  [
    "#search",
    "Start with a name—or a feeling.",
    "დაიწყეთ სახელით ან იდეით.",
    "Search a font or designer here. Looking for a particular style? The filters beside the list help narrow it down.",
    "მოძებნეთ შრიფტი ან დიზაინერი. კონკრეტული სტილი გინდათ? გვერდით არსებული ფილტრები არჩევანს შეგიზღუდავთ.",
  ],
  [
    "#sidebar",
    "Make the collection yours.",
    "მოარგეთ კოლექცია თქვენს იდეას.",
    "Filter by encoding, writing system, and style. Building a new website? Unicode is a good place to start.",
    "გაფილტრეთ კოდირებით, დამწერლობითა და სტილით. ახალ ვებსაიტს ქმნით? დაიწყეთ Unicode-ით.",
  ],
  [
    ".previewbar",
    "Your words. Every font.",
    "თქვენი სიტყვები. ყველა შრიფტში.",
    "Choose a sample or type your own. Use ქართული to type Georgian with an English keyboard, or English for ordinary typing. Adjust the size to see how the text feels.",
    "აირჩიეთ ნიმუში ან ჩაწერეთ საკუთარი ტექსტი. ქართული რეჟიმი ინგლისური კლავიატურით ქართულად გაწერინებთ; English უცვლელად შეიყვანს ტექსტს. მოსინჯეთ სხვადასხვა ზომაც.",
  ],
  [
    ".fontcard .cardname",
    "Meet a font properly.",
    "გაიცანით შრიფტი ახლოდან.",
    "Click a font’s name to open its specimen, glyphs, In use examples, and license details. The heart saves it to your collection in this browser.",
    "დააჭირეთ სახელს ნიმუშის, სიმბოლოების, გამოყენების მაგალითებისა და ლიცენზიის სანახავად. გული შრიფტს ამ ბრაუზერის რჩეულებში შეინახავს.",
  ],
  [
    ".fontcard .samplelink",
    "See it in a real design.",
    "ნახეთ შრიფტი დიზაინში.",
    "Sample previews opens the large studio. Try a newspaper, website, banner, or poster—and switch fonts without leaving your design.",
    "გამოყენების ნიმუშები დიდ სტუდიას ხსნის. მოსინჯეთ გაზეთი, ვებსაიტი, ბანერი ან პოსტერი და შეცვალეთ შრიფტები დიზაინიდან გაუსვლელად.",
  ],
  [
    ".fontcard [data-compare]",
    "Can’t choose? Compare.",
    "არჩევა გიჭირთ? შეადარეთ.",
    "Add up to four fonts with this button, then open Compare fonts. You can drag the floating comparison bar out of your way using its dotted handle.",
    "ამ ღილაკით დაამატეთ მაქსიმუმ ოთხი შრიფტი და გახსენით შედარება. მცურავი ზოლის გადასაადგილებლად გამოიყენეთ წერტილოვანი სახელური.",
  ],
  [
    ".fontcard [data-embed-add]",
    "Put this font on your own website.",
    "გამოიყენეთ თქვენს ვებსაიტზე.",
    "Click </> to preview selected fonts and get your embed code. Copy the stylesheet link into your page, then the font-family rule into your CSS. Fontlab delivers the files through Cloudflare. Check the license before publishing.",
    "დააჭირეთ </>-ს ნიმუშებისა და ჩასმის კოდის სანახავად. ჩასვით სტილის ბმული თქვენს გვერდში და font-family წესი CSS-ში. Fontlab ფაილებს Cloudflare-ით მიაწვდის. გამოქვეყნებამდე შეამოწმეთ ლიცენზია.",
  ],
  [
    'nav a[href="#studio"]',
    "Your design playground is always here.",
    "დიზაინის სტუდია ყოველთვის აქ არის.",
    "Open Preview studio any time. Its font chooser is a miniature explorer with live samples, search, filters, and grid or list views.",
    "გახსენით ნიმუშების სტუდია ნებისმიერ დროს. შრიფტის ამრჩევი პატარა კატალოგია ცოცხალი ნიმუშებით, ძიებით, ფილტრებითა და ბადის ან სიის ხედით.",
  ],
  [
    'nav a[href="#converter"]',
    "Old text deserves a fresh start.",
    "ძველ ტექსტს ახალი სიცოცხლე მიეცით.",
    "Use Converter for text stored in an older encoding. Pick the source and destination, test a short sample, then copy your converted text. Changing the font alone won’t convert it.",
    "ძველი კოდირების ტექსტისთვის გამოიყენეთ კონვერტერი. აირჩიეთ საწყისი და საბოლოო კოდირება, შეამოწმეთ მოკლე ნიმუში და დააკოპირეთ შედეგი. მხოლოდ შრიფტის შეცვლა ტექსტს არ გარდაქმნის.",
  ],
  [
    'nav a[href="#help"]',
    "Keep exploring. You’re ready.",
    "გააგრძელეთ აღმოჩენა. მზად ხართ.",
    "Help is your hands-on type school: explore Georgian scripts, try live conversion, and learn web embedding. You can replay this tour any time with the ? button.",
    "დახმარება თქვენი პრაქტიკული სკოლაა: გაიცანით დამწერლობები, სცადეთ კონვერტაცია და ისწავლეთ ვებსაიტზე ჩასმა. ტურის გამეორება ნებისმიერ დროს შეგიძლიათ ? ღილაკით.",
  ],
];
